"use client";

import { useCallback, useEffect, useState } from "react";
import Image from "next/image";
import Button from "@components/atoms/Button";
import { WishlistButtonProps } from "./WishlistButton.types";
import { WISHLIST_CONFIG } from "./WishlistButton.data";
import styles from "./WishlistButton.module.scss";
import assetLoader from "@utils/internalImageLoder";
import { getLoginUrl } from "@utils/getLoginUrl";
import { trackEventWithCommonProps, EventType } from "@utils/eventTracker";
import { PAGE_TYPES } from "@constants/pageTypes";
import { getPageNameFromUrl } from "@utils/pageNameUtils";
import { usePathname } from "next/navigation";

const WishlistButton = ({
  isLoggedIn,
  isInWishlist,
  onWishlistClick,
  className = "",
  size = "medium",
  model_name,
  brand_name,
  cityName,
  status,
  title,
  isCampaignPage
}: WishlistButtonProps) => {

  const pathname = usePathname();

  const handleWishlistClick = useCallback(
    async (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();

      await trackEventWithCommonProps("action", EventType.TRACK_EVENT, {
        pageType: getPageNameFromUrl(pathname),
        additionalProps: {
          action_type: "tap_btn",
          action_name: "tap_btn_wishlist_car",
          car_availability: status === "sellable" ? "yes" : "no",
          vehicle_make: brand_name,
          vehicle_model: model_name,
          city_name: cityName,
          ...(getPageNameFromUrl(pathname) == "Collection page" && {
            collection_name: title,
          }),
        },
      });

      if (!isLoggedIn) {
        // Only access window on client side
        if (typeof window !== "undefined") {
          sessionStorage.setItem("loginType", "Wishlist");
          localStorage.setItem(
            "MMV",
            JSON.stringify({
              make: brand_name,
              model: model_name,
            })
          );
          window.location.href = getLoginUrl(window.location.href);
        }
      } else {
        onWishlistClick?.();
      }
    },
    [
      isLoggedIn,
      onWishlistClick,
      pathname,
      status,
      brand_name,
      model_name,
      cityName,
    ]
  );

  const iconSize = WISHLIST_CONFIG.iconSizes[size];

  return (
    <Button
      className={`${styles.wishlistButton} ${isCampaignPage ? styles.isCampaignPage: ""} ${className}`}
      onClick={handleWishlistClick}
      aria-label={
        isInWishlist
          ? WISHLIST_CONFIG.ariaLabel.remove
          : WISHLIST_CONFIG.ariaLabel.add
      }
      variant="secondary"
    >
      <Image
        src={
          isInWishlist
            ? `${assetLoader()}/icons/wishlist-favourite.svg`
            : `${assetLoader()}/icons/wishlist.svg`
        }
        alt={
          isInWishlist
            ? WISHLIST_CONFIG.ariaLabel.remove
            : WISHLIST_CONFIG.ariaLabel.add
        }
        width={iconSize}
        height={iconSize}
        className={styles.wishlistIcon}
        loading="eager"
      />
    </Button>
  );
};

export default WishlistButton;
